//@ts-check

/**@type {import("./types").FormFieldValidatorCharacters} */
var shouldNotContainChars = function shouldNotContainChars(value, chars) {
  var errors = chars.filter(function (char) {
    return value.indexOf(char) > -1;
  });
  if (errors.length) return 'Invalid characters ' + errors.join('');
  return undefined;
};
/**@type {import("./types").FormFieldValidatorCharacters} */


var shouldContainChars = function shouldContainChars(value, chars) {
  var errors = chars.filter(function (char) {
    return value.indexOf(char) === -1;
  });
  if (errors.length) return 'Missing characters ' + errors.join('');
  return undefined;
};
/**@type {import("./types").FormFieldValidatorLength} */


var shouldHaveMaxLength = function shouldHaveMaxLength(value, length) {
  if (value.length > length) return 'Max size is ' + length;
  return undefined;
};
/**@type {import("./types").FormFieldValidatorSpecified} */


var shouldBeSpecified = function shouldBeSpecified(value) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Name';
  if (!value) return name + ' is required';
  if (value.trim() == '') return 'Enter ' + name;
  return undefined;
};

var isLetter = function isLetter(c) {
  return c.toLowerCase() != c.toUpperCase();
};

var shouldStartWithALetterOrUnderscore = function shouldStartWithALetterOrUnderscore(value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!isLetter(value.charAt(0)) && value.charAt(0) !== '_') return message || 'Form name must start with a letter or underscore';
  return undefined;
};

var shouldEndWithALetterOrUnderscore = function shouldEndWithALetterOrUnderscore(value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var lastCahr = value.charAt(value.length - 1);
  if (!isLetter(lastCahr) && lastCahr !== '_') return message || 'Form name must end with a letter or underscore';
  return undefined;
};

var specialCharacters = ['#', '%', '}', '{', '/', '\\', '!', '<', '>', ':', '*', '|', '?', '$', '@', '^', '.', "'", ';', '[', ']', '(', ')', '+', '"', ',', '_', '-', '\'', '~', '=', '`'];
var specialCharactersEnvName = ['#', '%', '}', '{', '/', '\\', '!', '<', '>', '*', '|', '?', '$', '@', '^', "'", '[', ']', '(', ')', '+', '"', '\'', '~', '=', '`', ':'];
export default {
  shouldNotContainChars: shouldNotContainChars,
  shouldContainChars: shouldContainChars,
  shouldHaveMaxLength: shouldHaveMaxLength,
  shouldBeSpecified: shouldBeSpecified,
  shouldStartWithALetterOrUnderscore: shouldStartWithALetterOrUnderscore,
  shouldEndWithALetterOrUnderscore: shouldEndWithALetterOrUnderscore,
  specialCharacters: specialCharacters,
  specialCharactersEnvName: specialCharactersEnvName
};